import React from 'react'
import BoardComponent from '../components/BoardComponent'

function Home(props) {
  return (
    <div>
      <BoardComponent />
    </div>
  )
}

export default Home
